import axios from '../../axios'

/*
 * 手机号管理省份微信分省群数据接口
 */

// 获取分省群列表
export const getProvinceWxGroupList = (data) => {
    return axios({
        url: '/api/admin/mobile/province/group/page',
        method: 'get',
        data
    })
}

// 新增分省群信息
export const saveProvinceWxGroup = (data) => {
    return axios({
        url: '/api/admin/mobile/province/group/save',
        method: 'post',
        data
    })
}

// 编辑分省群信息
export const updateProvinceWxGroup = (data) => {
    return axios({
        url: '/api/admin/mobile/province/group/update',
        method: 'put',
        data
    })
}

// 删除分省群列表
export const deleteProvinceWxGroup = (data) => {
    return axios({
        url: '/api/admin/mobile/province/group/delete',
        method: 'delete',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/crm/group.js